import { constants } from '@/helpers/constants';
import { pageTitles } from '@/constants/navigation';

const { roles, newRoles } = constants;
const {
	jobs,
	staff,
	feedback,
	reports,
	exportPreferences,
	institutionSettings,
	options,
	systemSettings,
	departmentList,
	privacyPolicy,
	preferencesConfiguration,
	productConfiguration,
	managersList,
	jobMatchingPredictions,
	rateEsclationConfiguration,
	staffPersonaMappings,
	jobTemplateMappings,
	staffPersona,
	jobTemplates,
	skills,
	tags,
	trust,
	trustDetails,
	rightToWorkRequests,
	userList,
	modelJobList,
} = pageTitles;

const adminRoutes = [
	{
		name: jobs,
		link: { path: '/jobs/list' },
	},
	{
		name: staff,
		link: { name: 'staff-approved' },
	},
	{
		name: reports,
		link: { name: 'reports' },
		auth: true,
	},
	{
		name: institutionSettings,
		link: { name: 'institution' },
	},
	{
		name: staffPersonaMappings,
		link: { name: 'staffPersonaMappings' },
	},
	{
		name: jobTemplateMappings,
		link: { name: 'jobTemplateMappings' },
	},
	{
		name: jobTemplates,
		link: { name: 'job-templates' },
	},
	{
		name: options,
		link: { name: 'options' },
	},
	{
		name: systemSettings,
		link: { name: 'bank-rates' },
	},
	{
		name: departmentList,
		link: { name: 'department-list' },
	},
	{
		name: trust,
		link: { name: 'trust' },
	},
	{
		name: managersList,
		link: { name: 'managers' },
	},
	{
		name: jobMatchingPredictions,
		link: { name: 'job-matching-predictions' },
	},
	{
		name: exportPreferences,
		link: { name: 'export-preferences' },
	},
	{
		name: privacyPolicy,
		link: { name: 'configuration' },
	},
	{
		name: preferencesConfiguration,
		link: { name: 'preferences-configuration' },
	},
	{
		name: rateEsclationConfiguration,
		link: { name: 'rate-esclation-configuration' },
	},
	{
		name: productConfiguration,
		link: { name: 'product-configuration' },
	},
	{
		name: staffPersona,
		link: { name: 'staff-persona' },
	},
	{
		name: skills,
		link: { name: 'skills' },
	},
	{
		name: tags,
		link: { name: 'tags' },
	},
];

const trustAdminRoutes = [
	{
		name: trustDetails,
		link: { name: 'trustDetails' },
	},
	{
		name: rightToWorkRequests,
		link: { name: 'rightToWorkRequests' },
	},
	{
		name: userList,
		link: { name: 'userList' },
	},
	{
		name: modelJobList,
		link: { name: 'modelJobList' },
	},
];

const managerRoutes = [
	{
		name: jobs,
		link: { path: '/jobs/list' },
	},
	{
		name: staff,
		link: { name: 'staff-approved' },
	},
	{
		name: feedback,
		link: { name: 'feedbacks' },
	},
	{
		name: systemSettings,
		link: { name: 'bank-rates' },
	},
	{
		name: managersList,
		link: { name: 'managers' },
	},
];

const shiftManagerRoutes = [
	{
		name: jobs,
		link: { path: '/jobs/list' },
	},
	{
		name: staff,
		link: { name: 'staff-approved' },
	},
	{
		name: feedback,
		link: { name: 'feedbacks' },
	},
];

export default {
	state: {
		// selectedItem: "Reports",
		[newRoles.superAdmin]: adminRoutes,
		[newRoles.trustAdmin]: trustAdminRoutes,
		[newRoles.bankOfficerManager]: managerRoutes,
		[newRoles.operationalManager]: managerRoutes,
		[newRoles.shiftManager]: shiftManagerRoutes,
		// [roles.admin]: adminRoutes,
		// [roles.bankOfficerManager]: managerRoutes,
		// [roles.operationalManager]: managerRoutes,
		// [roles.shiftManager]: shiftManagerRoutes,
		others: [
			{
				name: jobs,
				link: { path: '/jobs/list' },
			},
			{
				name: staff,
				link: { name: 'staff-approved' },
			},
		],
	},
	getters: {
		menu: (state) => state,
	},
};
